import api from './api'

export const authService = {
    login: async (username, password) => {
        const response = await api.post('/auth/login', { username, password })
        if (response?.token) {
            localStorage.setItem('token', response.token)
            localStorage.setItem('user', JSON.stringify(response.user))
        }
        return response
    },

    logout: () => {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
    },

    getCurrentUser: () => {
        const user = localStorage.getItem('user')
        return user ? JSON.parse(user) : null
    },

    isAuthenticated: () => {
        return !!localStorage.getItem('token')
    }
}

export default authService
